export default "__VITE_ASSET__DPbzsvsy__"